import React from 'react'
import { TextField, RaisedButton } from 'material-ui';
import { cyan900 } from 'material-ui/styles/colors';

const host = window.location.hostname
const local = (host.indexOf("local") > -1);
const staging = host.indexOf('staging') > -1;
const develop = (host.indexOf('develop.') > -1)

const SageInfo = ({ sageId, nsOrderId, nsOrderNumber}) => {
  const netSuiteLink = (local || staging || develop) 
            ? `https://6326154-sb1.app.netsuite.com/app/accounting/transactions/salesord.nl?id=${nsOrderId}` 
            : `https://6326154.app.netsuite.com/app/accounting/transactions/salesord.nl?id=${nsOrderId}`
  const styles = {
    floatingLabelStyle: {
      color: cyan900,
    },
    inputStyle: {
      marginRight: '4%',
      width: '250px',
    },
  };
  return (
    <div className="sage-info-container" style={{ paddingLeft: '40px', paddingBottom: '20px' }}>
      <TextField
        floatingLabelText="Sage Id"
        floatingLabelStyle={styles.floatingLabelStyle}
        floatingLabelFixed={true}
        value={sageId}
        name="sageId"
        disabled
        style={styles.inputStyle}
      />
      <TextField
        floatingLabelText="NetSuite Order Number"
        floatingLabelStyle={styles.floatingLabelStyle}
        floatingLabelFixed={true}
        value={nsOrderNumber}
        name="nsOrderNumber"
        disabled
        style={styles.inputStyle}
      />
      {nsOrderId &&
        <a href={netSuiteLink} target="_blank">
          <RaisedButton
            label="NetSuite Link"
            style={{ marginBottom: '20px', marginRight: '10px' }}
            primary
          />
        </a>
      }
    </div>
  )
}

export default SageInfo


// WEBPACK FOOTER //
// ./src/components/orders/Common/SageInfo.js